import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { setError } from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { mapToObjectDDL } from "../../../../common/mapper";
import { monthOptions, yearOptions } from "../../config";
import { tableConfig } from "./config";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";

class DashboardProspekMonitoringKabengKacab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllSelected: true,
      isSpecificSelected: false,
      cabangOptions: [],
      kodeCabang: null,
      month: null,
      year: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  loadDDL = () => {
    const currentMonth = Number(moment().format("MM"));
    const currentYear = Number(moment().format("YYYY"));
    this.setState(
      {
        month: monthOptions.find((item) => item.value === currentMonth),
        year: yearOptions.find((item) => item.value === currentYear),
      },
      () => {
        this.fetchDataCabang();
      }
    );
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Monitoring",
    });
    this.handleTriggerLoading();
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        const cabang = filteredData.map((item) =>
          mapToObjectDDL(item.namaDealer, item.kodeCabang)
        );
        this.setState(
          (prev) => ({
            ...prev,
            cabangOptions: cabang,
          }),
          () => this.fetchData()
        );
      }
    }
  };

  fetchData = async () => {
    const { setError } = this.props;
    const { kodeCabang, year, month, isAllSelected, cabangOptions } =
      this.state;

    const cabang = isAllSelected ? cabangOptions : kodeCabang || [];

    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikProspectCabang,
      menuName:
        "Dashboard Prospek Monitoring - Laporan Statistik Prospek Cabang",
      setError: setError,
      args: {
        listCabang: cabang.map((item) => item.value),
        year: year?.value,
        month: month?.value,
      },
    });
    this.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  handleSelectCabangType = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  render() {
    const {
      isAllSelected,
      isSpecificSelected,
      cabangOptions,
      kodeCabang,
      month,
      year,
      loading,
      dataTable
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView
            style={{ gap: "20px", alignItems: "center" }}
            className="margin-top-15px"
          >
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={isAllSelected}
              onChange={(e) => this.handleSelectCabangType(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={isSpecificSelected}
              onChange={(e) => this.handleSelectCabangType(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px"
              placeholder="Nama Cabang"
              readOnly={!isSpecificSelected}
              options={cabangOptions}
              value={kodeCabang}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
          </FlexView>
          <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
            <SimpleDDL
              id="select_options_bulan"
              box="search"
              name="month"
              containerclassname="width width-150px"
              placeholder="Bulan"
              options={monthOptions}
              value={month}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
            <SimpleDDL
              id="select_options_tahun"
              box="search"
              name="year"
              containerclassname="width width-150px"
              placeholder="Tahun"
              options={yearOptions}
              value={year}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
            <SimpleButton
              id="btn_search"
              text="Cari"
              className="margin margin-top-5px"
              onClick={this.fetchData}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Statistik Prospek Cabang</Tab>
            </TabList>
            <TabPanel key="prospek_cabang">
              <SimpleDataTable
                data={dataTable || []}
                columns={tableConfig}
                options={{ pagination: false }}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(setError(payload)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardProspekMonitoringKabengKacab);
